var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { useCombobox } from 'downshift';
import { XIcon } from '../icons/index.js';
import { Input } from '../Input/index.js';
import { FloatingContextProvider, useFloatingContext, } from '../utils/floating/index.js';
import { AutocompleteContext, useAutocomplete } from './AutocompleteContext.js';
import { AutocompleteItem, AutocompleteItems, AutocompleteItemsEmpty, } from './AutocompleteItems.js';
export const Autocomplete = (props) => {
    const { itemToString, children, options, onChange, className, disabled = false, loading = false, onInputChange, defaultHighlightedIndex, clearInputOnSelect = false, clearInputOnBlur = false } = props, rest = __rest(props, ["itemToString", "children", "options", "onChange", "className", "disabled", "loading", "onInputChange", "defaultHighlightedIndex", "clearInputOnSelect", "clearInputOnBlur"]);
    const dsCombobox = useCombobox({
        itemToString,
        items: options,
        defaultHighlightedIndex,
        onSelectedItemChange: changes => {
            onChange(changes.selectedItem);
        },
        onInputValueChange: changes => {
            onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(changes.inputValue);
        },
        stateReducer: (state, actionAndChanges) => {
            const { changes, type } = actionAndChanges;
            switch (type) {
                case useCombobox.stateChangeTypes.InputKeyDownEnter:
                case useCombobox.stateChangeTypes.ItemClick:
                    if (clearInputOnSelect) {
                        return Object.assign(Object.assign({}, changes), { inputValue: '' });
                    }
                    return changes;
                case useCombobox.stateChangeTypes.InputBlur:
                    if (clearInputOnBlur) {
                        return Object.assign(Object.assign({}, changes), { inputValue: '' });
                    }
                    return changes;
                default:
                    return changes;
            }
        },
    });
    return (React.createElement("div", Object.assign({ className: clsx('relative isolate', className) }, rest),
        React.createElement(AutocompleteContext.Provider, { value: Object.assign(Object.assign({}, dsCombobox), { disabled,
                loading }) },
            React.createElement(FloatingContextProvider, { placement: "bottom-start" }, children))));
};
export const AutocompleteInput = props => {
    const { className, placeholder, leadingIcon, onEnter, showClearButton = true } = props, rest = __rest(props, ["className", "placeholder", "leadingIcon", "onEnter", "showClearButton"]);
    const { disabled, getComboboxProps, getInputProps, reset, highlightedIndex, inputValue, } = useAutocomplete();
    const { reference } = useFloatingContext();
    const clearButton = (React.createElement("button", { type: "button", "aria-label": "clear selection", onClick: e => {
            e.stopPropagation();
            reset();
        } },
        React.createElement(XIcon, { className: "w-5 h-5 text-basicSurface-400", "aria-hidden": "true" })));
    const onKeyDown = event => {
        if (event.key === 'Enter') {
            onEnter === null || onEnter === void 0 ? void 0 : onEnter({ highlightedIndex, inputValue });
        }
    };
    return (React.createElement("div", { ref: reference },
        React.createElement("div", Object.assign({}, getComboboxProps({ disabled })),
            React.createElement(Input, Object.assign({}, getInputProps(Object.assign({ placeholder,
                disabled,
                className,
                onKeyDown }, rest)), { leadingIcon: leadingIcon, trailingAddon: showClearButton && !!inputValue && clearButton })))));
};
Autocomplete.Input = AutocompleteInput;
Autocomplete.Items = AutocompleteItems;
Autocomplete.ItemsEmpty = AutocompleteItemsEmpty;
Autocomplete.Item = AutocompleteItem;
//# sourceMappingURL=Autocomplete.js.map